/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PostOPSurgeonNotes from './post-op-surgeon-notes';
import PostOPSurgeonNotesDetail from './post-op-surgeon-notes-detail';
import PostOPSurgeonNotesUpdate from './post-op-surgeon-notes-update';
import PostOPSurgeonNotesDeleteDialog from './post-op-surgeon-notes-delete-dialog';

const PostOPSurgeonNotesRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PostOPSurgeonNotes />} />
    <Route path="new" element={<PostOPSurgeonNotesUpdate />} />
    <Route path=":id">
      <Route index element={<PostOPSurgeonNotesDetail />} />
      <Route path="edit" element={<PostOPSurgeonNotesUpdate />} />
      <Route path="delete" element={<PostOPSurgeonNotesDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PostOPSurgeonNotesRoutes;
